import { render } from "./Header.vue.ts?vue&type=template&id=d5b344ab&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Header.vue?vue&type=template&id=d5b344ab&scoped=true&ts=true"
import script from "./Header.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Header.vue?vue&type=script&setup=true&lang=ts"
export * from "./Header.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Header.vue?vue&type=script&setup=true&lang=ts"

import "./Header.vue.scss?vue&type=style&index=0&id=d5b344ab&lang=scss&scoped=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Header.vue?vue&type=style&index=0&id=d5b344ab&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5b344ab"],['__file',"src/apps/person-registration/shared-components/common/Header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d5b344ab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d5b344ab', __exports__)) {
    api.reload('d5b344ab', __exports__)
  }
  
  module.hot.accept("./Header.vue.ts?vue&type=template&id=d5b344ab&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Header.vue?vue&type=template&id=d5b344ab&scoped=true&ts=true", () => {
    api.rerender('d5b344ab', render)
  })

}


export default __exports__